import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// models
import { ApplicationSettings } from '../../../shared/models/application-settings';

import { DistributionNumberRange } from '../../../shared/models/distribution-number-range';
import { DistributionNumber, DistributionNumberSuggestion } from '../../../shared/models/distribution-number';

// services
import { WebApiService } from '../../../shared/services/web-api.service';
import { AnySoaRecord } from 'dns';


@Injectable()
export class DistributionManagementService {

  private apiPath: string;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'auctioncluster';
  }

  getDistributionNumberRangesPaged(auctionClusterId: number, loadOptions: any) {
    let url = this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumberranges/paged';
    var params = this.webApiService.getParamsFromLoadOptions(loadOptions);
    let result = this.webApiService.getWithParams(url, params);
    return result;
  }

  getDistributionNumberRange(auctionClusterId: number, distributionNumberRangeId: number): Observable<DistributionNumberRange> {
    return this.webApiService.get(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumberranges', distributionNumberRangeId);
  }

  saveDistributionNumberRange(auctionClusterId: number, distributionNumberRange: DistributionNumberRange): Observable<any> {
    return this.webApiService.save<DistributionNumberRange>(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumberranges', distributionNumberRange);
  }

  editDistributionNumberRange(auctionClusterId: number, distributionNumberRange: DistributionNumberRange): Observable<any> {
    return this.webApiService.edit<DistributionNumberRange>(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumberranges', distributionNumberRange.distributionNumberRangeId, distributionNumberRange);
  }

  deleteDistributionNumberRange(auctionClusterId: number, distributionNumberRangeId: number): Observable<any> {
    return this.webApiService.delete(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumberranges', distributionNumberRangeId);
  }

  getDistributionNumbersPaged(auctionClusterId: number, loadOptions: any, getFixedNumbers: boolean) {
    let url = this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumbers/paged/fixednumbers/' + getFixedNumbers;
    var params = this.webApiService.getParamsFromLoadOptions(loadOptions);
    let result = this.webApiService.getWithParams(url, params);
    return result;
  }

  getDistributionNumber(auctionClusterId: number, distributionNumberId: number): Observable<DistributionNumber> {
    return this.webApiService.get(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumbers', distributionNumberId);
  }

  saveDistributionNumber(auctionClusterId: number, distributionNumber: DistributionNumber): Observable<any> {
    return this.webApiService.save<DistributionNumber>(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumbers', distributionNumber);
  }

  editDistributionNumber(auctionClusterId: number, distributionNumber: DistributionNumber): Observable<any> {
    return this.webApiService.edit<DistributionNumber>(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumbers', distributionNumber.distributionNumberId, distributionNumber);
  }

  deleteDistributionNumber(auctionClusterId: number, distributionNumberId: number): Observable<any> {
    return this.webApiService.delete(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/distributionnumbers', distributionNumberId);
  }

  checkDeletePossible(auctionClusterId: number): Observable<any> {
    return this.webApiService.getSingle(this.apiPath + '/' + auctionClusterId + '/distributionmanagement/checkdeletepossible');
  }

  getDistributionNumberSuggestion(auctionClusterId: number, masterDataListRowId: number): Observable<DistributionNumberSuggestion> {
    let url = this.apiPath + '/' + auctionClusterId + 
    '/distributionmanagement/distributionnumbers/suggestion/category/' + masterDataListRowId;
    return this.webApiService.getSingle(url);
  }
}